// Modules
import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const Container = styled.div`
    overflow-x: hidden;
    min-height: 100%;
    * {
        padding: 0;
        margin: 0;
        border: 0;
        box-sizing: border-box;
        font-family: 'Dasa Sans', 'Montserrat', sans-serif !important;
    }
    a {
        color: ${theme.colors.primary};
    }
`

export const ToastButton = styled.div`
    font-family: 'Dasa Sans', 'Montserrat', sans-serif;
    margin: 8px 4px;
    background: none;
    color: ${theme.colors.primary};
    text-decoration: underline;
    cursor: pointer;
`
